module.exports = __webpack_public_path__ + "static/media/logo.c95cc5c7.svg";